import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';
import { environment } from 'src/app/environments/environment.js';

@Component({
    templateUrl: './refund-policy.component.html',
    selector: 'mod-refund-policy',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RefundPolicyComponent extends CoreAppComponent {
	public readonly refundHref: string = `mailto:${environment.refundEmail}`;
	public readonly refundEmail: string = `${environment.refundEmail}`;
	
	constructor() {
		super();
	}
}
